export const getButtonColorWithTheme = (bootstrapName, theme) => {
    const ThemeColors = theme.ThemeColors;
    switch (bootstrapName) {
        case 'primary':
            return ThemeColors.PRIMARY;
        case 'secondary':
            return ThemeColors.SECONDARY;
        case 'tertiary':
            return ThemeColors.TERTIARY;
        case 'warning':
            return ThemeColors.WARNING;
        case 'danger':
            return ThemeColors.DANGER;
        case 'light':
            return ThemeColors.LIGHT;
        case 'dark':
            return ThemeColors.DARK;
        case 'success':
            return ThemeColors.SUCCESS;
        case 'info':
            return ThemeColors.INFO;
        default:
            return ThemeColors.PRIMARY;
    }
};
// If we want some color to have different shades for their hover, default is X600
const hoverShadeMap = { // 'MINE_SHAFT' : 'X600'   // Example
};
export function getHoverShade() {
    console.log('do we fail here');
    const customShade = hoverShadeMap[this.name];
    return customShade ? this[customShade] : this.X600;
}
export function makeBaseHex(color, xValue = 'X700') {
    return Object.assign({}, color, { hex: color[xValue] });
}
export function inDarkMode(theme) {
    return theme.Config && theme.Config.name === 'Dark Theme';
}
